import { IGeneralModel } from "./abstract/igeneralModel.interface";

export class GeneralModel implements IGeneralModel {
    code: string;
    name: string;
    concurrencyStamp: string;
    isEnabled: boolean = true;
    id: number;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/general.model.ts